/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-04-19 12:00:00
 *
 *******************************************************/

import React from 'react';
import { withI18n } from '@shopify/react-i18n';
import { Button, Icon, Link } from '@shopify/polaris';
import { routes } from 'src/routes';
import history from 'src/routes/history';
import { ExternalMinor } from '@shopify/polaris-icons';
import classNames from 'classnames';
import warnIcon from 'src/assets/images/common/warning.svg';

export const WarningType = {
  IN_THEME_SETUPV3_THEME_TURBO: 1,
  IN_SHOPIFY_INTEGRATION_THEME_V3: 2,
  IN_SHOPIFY_INTEGRATION_THEME_V3_MIXED_TURBO: 3,
  IN_SHOPIFY_INTEGRATION_THEME_LIVE: 4
};

const ThemeTurboWarning = props => {
  const {
    i18n,
    type,
    tenantApp,
    onRemoveOldVersion,
    isShowButton = true,
    isDefaultColor = false
  } = props;

  switch (type) {
    case WarningType.IN_THEME_SETUPV3_THEME_TURBO: {
      return (
        <div
          className={classNames('theme-turbo-warning', {
            'theme-turbo-warning--default': isDefaultColor
          })}>
          {!isDefaultColor && (
            <div className="icon">
              <img src={warnIcon} alt="warn" width={16} height={16} />
            </div>
          )}

          <div className="content">
            <b className="title">
              {i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.warning_inV3_Turbo_title')}
            </b>
            <ul>
              <li>
                {i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.warning_inV3_Turbo_label1')}
              </li>
              <li>
                {i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.warning_inV3_Turbo_label2')}
              </li>
            </ul>
            {isShowButton && (
              <Button onClick={() => history.push(routes.appPreferences.view())}>
                {i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.warning_inV3_Turbo_btn')}
              </Button>
            )}
          </div>
        </div>
      );
    }
    case WarningType.IN_SHOPIFY_INTEGRATION_THEME_V3: {
      return (
        <div
          className={classNames('theme-turbo-warning', {
            'theme-turbo-warning--default': isDefaultColor
          })}>
          {!isDefaultColor && (
            <div className="icon">
              <img src={warnIcon} alt="warn" width={16} height={16} />
            </div>
          )}

          <div className="content">
            <b className="title">
              {i18n.translate('AdminHTML.ShopifyIntegration.Integration.warning_inTurbo_V3_title')}
            </b>
            <ul>
              <li>
                {i18n.translate(
                  'AdminHTML.ShopifyIntegration.Integration.warning_inTurbo_V3_label1'
                )}
              </li>
              <li>
                {i18n.translate(
                  'AdminHTML.ShopifyIntegration.Integration.warning_inTurbo_V3_label2'
                )}
              </li>
            </ul>
            {isShowButton && (
              <Button primary onClick={onRemoveOldVersion}>
                {i18n.translate(
                  'AdminHTML.ShopifyIntegration.Integration.warning_inTurbo_remove_btn'
                )}
              </Button>
            )}
          </div>
        </div>
      );
    }
    case WarningType.IN_SHOPIFY_INTEGRATION_THEME_V3_MIXED_TURBO: {
      return (
        <div
          className={classNames('theme-turbo-warning', {
            'theme-turbo-warning--default': isDefaultColor
          })}>
          {!isDefaultColor && (
            <div className="icon">
              <img src={warnIcon} alt="warn" width={16} height={16} />
            </div>
          )}

          <div className="content">
            <b className="title">
              {i18n.translate(
                'AdminHTML.ShopifyIntegration.Integration.warning_inTurbo_V3MixedTurbo_title'
              )}
            </b>
            <ul>
              <li>
                {i18n.translate(
                  'AdminHTML.ShopifyIntegration.Integration.warning_inTurbo_V3MixedTurbo_label1'
                )}
              </li>
              <li>
                {i18n.translate(
                  'AdminHTML.ShopifyIntegration.Integration.warning_inTurbo_V3MixedTurbo_label2'
                )}
              </li>
            </ul>
            {isShowButton && (
              <Button primary onClick={onRemoveOldVersion}>
                {i18n.translate(
                  'AdminHTML.ShopifyIntegration.Integration.warning_inTurbo_remove_btn'
                )}
              </Button>
            )}
          </div>
        </div>
      );
    }
    case WarningType.IN_SHOPIFY_INTEGRATION_THEME_LIVE: {
      return (
        <div
          className={classNames('theme-turbo-warning', {
            'theme-turbo-warning--default': isDefaultColor
          })}>
          {!isDefaultColor && (
            <div className="icon">
              <img src={warnIcon} alt="warn" width={16} height={16} />
            </div>
          )}

          <div className="content">
            <b className="title">
              {i18n.translate(
                'AdminHTML.ShopifyIntegration.Integration.warning_inTurbo_live_title'
              )}
            </b>
            <div>
              {i18n.translate(
                'AdminHTML.ShopifyIntegration.Integration.warning_inTurbo_live_label1'
              )}
            </div>
            <div>
              {i18n.translate(
                'AdminHTML.ShopifyIntegration.Integration.warning_inTurbo_live_label2'
              )}
            </div>
            <div>
              {i18n.translate(
                'AdminHTML.ShopifyIntegration.Integration.warning_inTurbo_live_Goto',
                {
                  breadrumbs: (
                    <span className="img-new-tab">
                      <Link
                        external
                        url={`https://admin.shopify.com/store/${
                          tenantApp.tenantId.split('.')[0]
                        }/themes`}>
                        {i18n.translate(
                          'AdminHTML.ShopifyIntegration.Integration.warning_inTurbo_live_Goto_Breadcrumbs'
                        )}
                        <Icon source={ExternalMinor} color="interactive" />
                      </Link>
                    </span>
                  )
                }
              )}
            </div>
          </div>
        </div>
      );
    }
    default:
  }
};

export default withI18n()(ThemeTurboWarning);
